import * as THREE from 'three'
import BaseNode from '../Objects/BaseNode'

export default class DataParser
{

    constructor(data) 
    {
        this.data = data

        this.parseData()
    }

    parseData() {
        this.offchainNodes = []
        this.majorDappNodes = []
        this.clientNodes = []
        this.blockChainNodes = []

        this.data.forEach(element => {
            const node = new BaseNode(element.type)
            node.data = element
            node.category = element.category
            switch (node.type ) {
                case "external_dataset":
                    this.offchainNodes.push(node)
                    node.myParsedIndex = this.offchainNodes.length - 1
                    break;
                case "major_project":
                    this.majorDappNodes.push(node)
                    node.myParsedIndex = this.majorDappNodes.length - 1
                    break;
                case "customer_dapp":
                    this.clientNodes.push(node)
                    node.myParsedIndex = this.clientNodes.length - 1
                    break;
                case "blockchain":
                    this.blockChainNodes.push(node)
                    node.myParsedIndex = this.blockChainNodes.length - 1
                    break;
            }
            if (element.primary_blockchain != null) node.parentBlockchainIndex = this.checkBlockchainParent(element.primary_blockchain)
            if (node.type == "major_project") {
                this.blockChainNodes[node.parentBlockchainIndex].numberOfDapps++
                node.dappChildIndex = this.blockChainNodes[node.parentBlockchainIndex].numberOfDapps - 1
            }
            this.setColors(node)
        });
    }

    checkBlockchainParent(inName) {
        let foundIt = false
        for (let i = 0; i < this.blockChainNodes.length; i++) {
            if (this.blockChainNodes[i].data.name == inName) {
                foundIt = true
                return i
            }
        }
        const newBlockchainNode = new BaseNode('blockchain')
        newBlockchainNode.data = 
        {
            name: inName
        }
        this.blockChainNodes.push(newBlockchainNode)
        newBlockchainNode.myParsedIndex = this.blockChainNodes.length - 1
        this.setColors(newBlockchainNode)
        return  newBlockchainNode.myParsedIndex
    }

    setColors(node) {
        if (node.type != "major_project") {
            if (node.data.base_color) node.colorA = node.data.base_color
            else node.colorA = this.random_rgba()
            if (node.data.base_color && node.data.secondary_color) node.colorB = node.data.secondary_color
            else node.colorB = node.colorA
        } else {
            if (node.data.base_color) node.colorA = node.data.base_color
            else node.colorA = this.blockChainNodes[node.parentBlockchainIndex].colorA
            if (node.data.base_color && node.data.secondary_color) node.colorB = node.data.secondary_color
            else node.colorB = this.blockChainNodes[node.parentBlockchainIndex].colorB
        }
    }


    random_rgba() {
        var o = Math.round, r = Math.random, s = 255;
        return 'rgb(' + o(r()*s) + ',' + o(r()*s) + ',' + o(1*s)  + ')';
    }

}